import { DefaultState } from './default-state.type';
import { ViewMode } from './view-mode.enum';

export const defaultState: DefaultState = {
	viewMode: ViewMode.notSet
};
